import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { ufolog } from '../../logger';
import { UFOExperienceState } from '../core';
var isUntilExperience = function isUntilExperience(until) {
  return until.experience !== undefined;
};
var isUntilCategory = function isUntilCategory(until) {
  return until.category !== undefined;
};
export var untilAll = function untilAll(deps) {
  return function () {
    var notMet = _toConsumableArray(deps);
    return function (data) {
      if (notMet.length > 0) {
        var doneIndexes = notMet.reduce(function (acc, dep, i) {
          // validation logic
          if (isUntilExperience(dep) && dep.experience.uuid === data.uuid) {
            acc.push(i);
          } else if (isUntilCategory(dep) && dep.category === data.category) {
            acc.push(i);
          }
          return acc;
        }, []);
        var priorityStateFound = data.state === UFOExperienceState.ABORTED || data.state === UFOExperienceState.FAILED;
        if (priorityStateFound) {
          notMet.length = 0;
          return {
            done: true,
            state: data.state
          };
        }
        doneIndexes.reverse().forEach(function (i) {
          notMet.splice(i, 1);
        });
        ufolog('untilAll deps left:', notMet.length, notMet);
        if (notMet.length === 0) {
          return {
            done: true,
            state: UFOExperienceState.SUCCEEDED
          };
        }
      }
      return {
        done: false
      };
    };
  };
};